<template>
  <confirmation-list :manifests="manifests" />
</template>

<script>
import { mapActions } from 'vuex'
import ConfirmationList from '../../../components/_ConfirmationList'

export default {
  name: 'DriverOrderConfirmationList',
  components: {
    ConfirmationList
  },
  mixins: [],
  props: {},
  data() {
    return {
      manifests: null,
    }
  },
  computed: {},
  watch: {},
  created() {
    const params = this.$route.query
    this.fetchManifests({ params: params }).then((content) => {
      this.manifests = content.manifests
    })
  },
  methods: {
    ...mapActions('DriverOrderConfirmationList', {
      fetchManifests: 'index',
    }),
  }
}
</script>
